import styled, { css } from 'styled-components';

import footerSpritesheet from '../../../assets/images/footer-spritesheet-dark.png';

const Spritesheet = styled.div`
  background-image: url(${footerSpritesheet});
`;

export const ResponsiblyLogo = styled(Spritesheet)`
  background-position: 0 0;
  width: 34px;
  height: 34px;
`;

export const ForbiddenLogo = styled(Spritesheet)`
  background-position: -40px 0;
  width: 34px;
  height: 34px;
`;

export const PaymentsLogo = styled(Spritesheet)`
  background-position: 0 -40px;
  height: 30px;
  width: 172px;

  ${({ $noPaypal }) =>
    $noPaypal &&
    css`
      width: 100px;
    `}
`;
